const ONBOARDING_EVENTS = {
  ONBOARDING_SUCCESS: 'ONBOARDING_SUCCESS',
  ONBOARDING_FAILURE: 'ONBOARDING_FAILURE',
}

export default ONBOARDING_EVENTS
